import React, { useEffect, useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import Glide from "@glidejs/glide";

import { SliderButton } from "../SliderButton";
import { Image, ImagePropTypes } from "../Image";

import styles from "./ModalGallery.scss";

const Gallery = ({ slides, thumbnails, imgProps }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [sliderInstance, setSliderInstance] = useState(null);

  useEffect(() => {
    const glide = new Glide(`.${styles.gallery}`, {
      type: "slider",
      startAt: 0,
      perView: 1,
      animationTimingFunc: "ease-in-out",
      rewind: false,
      keyboard: true,
    });

    glide.on("run.after", () => {
      // Setting index state after sliding animation is complete
      setCurrentIndex(glide.index);
    });
    glide.mount();
    setSliderInstance(glide);

    return () => {
      if (sliderInstance) {
        sliderInstance.destroy();
        setSliderInstance(null);
      }
    };
  }, []);

  const goNext = () => {
    sliderInstance.go(">");
  };

  const goPrev = () => {
    sliderInstance.go("<");
  };

  const goTo = (index) => {
    sliderInstance.go(`=${index}`);
  };

  return (
    <div className={styles.gallery}>
      <div className={styles.display}>
        <SliderButton
          variant="backwards"
          onClick={goPrev}
          customClass={styles["slider-button"]}
          disabled={currentIndex === 0}
        />
        <div className={styles.imageSliderTrack} data-glide-el="track">
          <ul className={styles.imageSlider}>
            {slides.map((slide, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <li className={styles.slide} key={index}>
                {slide && slide}
              </li>
            ))}
          </ul>
        </div>

        <SliderButton
          customClass={styles["slider-button"]}
          // data-glide-dir=">"
          onClick={goNext}
          disabled={currentIndex >= slides.length - 1}
        />
      </div>

      <ul className={styles.thumbnails}>
        {thumbnails.map((thumbnail, index) => (
          <li
            className={styles.thumbnail}
            // eslint-disable-next-line react/no-array-index-key
            key={index}
          >
            <button
              type="button"
              className={cx(styles.thumbnail__button, {
                [styles["thumbnail__button--active"]]: index === currentIndex,
              })}
              onClick={() => goTo(index)}
            >
              <Image
                src={thumbnail.src}
                alt={thumbnail.alt}
                className={styles["thumbnail-image"]}
                {...imgProps}
              />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

Gallery.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
  ).isRequired,
  thumbnails: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    })
  ).isRequired,
  imgProps: PropTypes.shape(ImagePropTypes),
};

Gallery.defaultProps = {
  imgProps: undefined,
};

Gallery.displayName = "ModalGallery.Gallery";

export default Gallery;
